module.exports = __webpack_public_path__ + "media/images/350x150-3-31b5271cd69363cf45f761a99890903a.jpg";